import {AxiosRequestConfig} from "axios"
import {CimpressAuth} from "../services/utilities/authClient"

export function getAxiosConfigWithAuth(): AxiosRequestConfig {
	return {
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
		},
	}
}

export function getAccessToken(): string {
	return CimpressAuth.getAccessToken()
}

export function getEmailFromAccessToken(): string {
	try {
		const profile = CimpressAuth.getProfile()
		if (!profile) return ""
		return profile["https://claims.cimpress.io/canonical_id"] ?? ""
	} catch (err) {
		console.error("unknownActo")
		return ""
	}
}
